<div class="container py-4">
    <h2 class="text-secondary">{{ title }}</h2>

    <br>

    <div *ngIf="$views === 2" class="py-3">
        <ng-container *ngTemplateOutlet="tableSolicitudesPendientes"></ng-container>

        <br>

        <div class="d-flex flex-row justify-content-center">
            <app-pagination [data]="paginationResponse" (setPagination)="getSolicitudes($event)">
            </app-pagination>
        </div>
    </div>

    <div *ngIf="$views === 5" class="py-3">
        <ng-container *ngTemplateOutlet="tableConsultaSolicitudes"></ng-container>
        <br>
        <div class="d-flex flex-row justify-content-center">
            <app-pagination [data]="paginationResponse" (setPagination)="getSolicitudes($event)">
            </app-pagination>
        </div>
    </div>

    <div>
        <form #reqRoute="ngForm">
            <!-- seccion 1 -->
            <ng-container *ngTemplateOutlet="seccion_1"></ng-container>

            <br>

            <!-- seccion 2 -->
            <ng-container *ngTemplateOutlet="seccion_2"></ng-container>

            <br>

            <!-- seccion 3 -->
            <ng-container *ngTemplateOutlet="seccion_3"></ng-container>

            <!-- seccion 4 observaciones Validacion de sdatos-->
            <div *ngIf="($views === 6 ) && (solicitud.txtObservacionDatosValidacion && solicitud.txtObservacionDatosValidacion.length> 0)">
                <!-- seccion 4 -->
                <ng-container *ngTemplateOutlet="seccion_4"></ng-container>
            </div>

            <!-- seccion 5 observaciones Rechazo directivo-->
            <div *ngIf="( $views === 6 ) && (solicitud.txtObservacionRechazo && solicitud.txtObservacionRechazo.length > 0)">
                <!-- seccion 5 -->
                <ng-container *ngTemplateOutlet="seccion_5"></ng-container>
            </div>

            <!-- seccion_novedades -->
            <div *ngIf="($views === 5 || $views === 6 || $views === 9) && (solicitud.novedades && solicitud.novedades.length > 0)">
                <ng-container *ngTemplateOutlet="seccion_novedades"></ng-container>
            </div>

            <!-- seccion_cancelacion -->
            <div *ngIf="$views === 5  && solicitud.motivoCancelacionId > 0">
                <ng-container *ngTemplateOutlet="seccion_cancelacion"></ng-container>
            </div>

            <!-- seccion_solicitudes_vinculadas -->
            <div *ngIf="solicitud.relacionadas &&  solicitud.relacionadas.length > 0">
                <ng-container *ngTemplateOutlet="seccion_solicitudes_vinculadas"></ng-container>
                <br>
            </div>

            <!-- seccion_validacion_datos -->
            <div *ngIf="$views === 2 && (solicitud.txtObservacionDatosValidacion !== '' && solicitud.txtObservacionDatosValidacion)">
                <ng-container *ngTemplateOutlet="seccion_validacion_datos"></ng-container>
                <br>
            </div>
        </form>
    </div>

    <div *ngIf="$views === 6">
        <ng-container *ngTemplateOutlet="seccion_botones_pantalla_6"></ng-container>
    </div>
</div>



<!-- ======================================================================================================= -->
<!-- ======================================================================================================= -->

<!-- ZONE TEMPLATES -->

<!-- TABLE SOLICITUDES PENDIENTES POR APROBACION -->
<ng-template #tableSolicitudesPendientes>
    <app-table-request-pending [data]="solicitudesPendientesAprobacion" (itemSelected)="getSolicitudById($event)"
        (checked)="validateCheck($event)" (solicitudSeleccionada)="getSolicitudSeleccionada($event)">
    </app-table-request-pending>
</ng-template>


<!-- TABLE SOLICITUDES DE SERVICIO DISPONIBLES -->
<ng-template #tableConsultaSolicitudes>
    <h6 class="text-secondary fw-bold">Consulta de solicitudes de servicio disponibles</h6>
    <br>
    <div class="d-flex flex-rol col-md-2 gap-2">
        <input id="typeahead-format" type="text" class="form-control" placeholder="Buscar"
            (keyup.enter)="getSolicitudes(paginationRequest)" [(ngModel)]="paginationRequest.palabraClave" />

        <button class="btn btn-outline-secondary btn-sm" (click)="getSolicitudes(paginationRequest)">
            <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
        </button>
    </div>
    <br>
    <app-table-consult-request [dataTable]="consultaSolicitudesDisponibles"
        (idSolicitudSeleccionada)="emitCodeSolicitud($event)" (getSolicitudById)="getSolicitudById($event)"
        (actionCancel)="cancelSolicitudDisponible.emit($event)"
        (solicitudSeleccionada)="getSolicitudDisponibleSeleccionada($event)">
    </app-table-consult-request>
</ng-template>


<!-- SECCION 1 Información básica del servicio -->
<ng-template #seccion_1>
    <div>
        <h6 class="text-secondary fw-bold">Información básica del servicio</h6>

        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <div class="p-4">
                <div class="row py-1 g-3">
                    <div class="col-md-4">
                        <label for="dtFechaPrestacionServicio" class="form-label">Fecha de la prestación del
                            servicio</label>
                        <input id="dtFechaPrestacionServicio" class="form-control" type="date"
                            [min]="$views == 2 ? null : actualDate" (change)="validDeliveryDate()"
                            [(ngModel)]="solicitud.dtFechaPrestacionServicio" name="dtFechaPrestacionServicio"
                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                    </div>


                    <div class="col-md-4">
                        <label for="dtFechaSolicitud" class="form-label">Fecha de solicitud</label>
                        <input id="dtFechaSolicitud" class="form-control" type="date"
                            [(ngModel)]="solicitud.dtFechaSolicitud" name="dtFechaSolicitud" disabled>
                    </div>

                    <div class="col-md-4">
                        <label for="id" class="form-label">Tipo de transporte</label>

                        <div class="row g-2">
                            <div class="col-md-6"
                                *ngFor="let typeTransport of $parametricList.typeTransportList; let i = index">
                                <div class="form-check">
                                    <input id="{{ typeTransport.idParametroDetalle }}" class="form-check-input"
                                        type="radio" name="TIP_TRANSPORTE" [value]="typeTransport.idParametroDetalle"
                                        [(ngModel)]="solicitud.tipoTransporteId" name="tipoTransporteId"
                                        (change)="seleccionarPasajeros()" #tipoTransporteId="ngModel"
                                        [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                                    <label class="form-check-label" for="{{ typeTransport.idParametroDetalle }}">
                                        {{ typeTransport.vcNombre }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row py-1 g-3">
                    <div class="col-md-4">
                        <label for="id" class="form-label">Cantidad de pasajeros</label>
                        <select class="form-select" aria-label="Default select example"
                            [(ngModel)]="solicitud.iCantidadPasajeros" name="iCantidadPasajeros"
                            #iCantidadPasajeros="ngModel" required
                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                            <option selected disabled>Seleccionar</option>
                            <option *ngFor="let typeQuantPassList of $parametricList.typeQuantPassList"
                                [value]="typeQuantPassList.vcNombre">
                                {{ typeQuantPassList.vcNombre }}
                            </option>
                        </select>

                        <strong class="invalid-feedback d-block"
                            *ngIf="iCantidadPasajeros.invalid && (iCantidadPasajeros.dirty || iCantidadPasajeros.touched || submitted)">
                            <span *ngIf="iCantidadPasajeros.errors?.['required']">
                                Campo obligatorio
                            </span>
                        </strong>
                    </div>

                    <div class="col-md-5">
                        <label for="id" class="form-label">Tipo de servicio</label>

                        <div class="row gap-md-3 d-flex flex-row">
                            <div class="col-md-3"
                                *ngFor="let typeServicesList of $parametricList.typeServicesList; let i = index">
                                <div class="form-check">
                                    <input id="{{ typeServicesList.idParametroDetalle }}" class="form-check-input"
                                        type="radio" name="TIP_SERVICIO" [value]="typeServicesList.idParametroDetalle"
                                        [(ngModel)]="solicitud.tipoServicioId" name="tipoServicioId"
                                        #tipoServicioId="ngModel"
                                        [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                                    <label class="form-check-label" for="{{ typeServicesList.idParametroDetalle }}">
                                        {{ typeServicesList.vcNombre }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- SECCION 2 Información del tipo de servicio -->
<ng-template #seccion_2>
    <div
        *ngIf="(solicitud.tipoTransporteId == $parametricList.typeTransportList[0]?.idParametroDetalle || solicitud.tipoTransporteId == $parametricList.typeTransportList[1]?.idParametroDetalle) && (solicitud.tipoServicioId == $parametricList.typeServicesList[0]?.idParametroDetalle || solicitud.tipoServicioId == $parametricList.typeServicesList[1]?.idParametroDetalle || solicitud.tipoServicioId == $parametricList.typeServicesList[2]?.idParametroDetalle)">
        <h6 class="text-secondary fw-bold">Información del tipo de servicio</h6>

        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3 py-4">
            <div class="px-4 py-2" *ngFor="let recorrido of solicitud.recorridos; let i=index">
                <fieldset class="p-4"
                    [ngClass]="{'border border-secondary rounded-3': solicitud.tipoTransporteId == $parametricList.typeTransportList[0].idParametroDetalle && solicitud.tipoServicioId == $parametricList.typeServicesList[0].idParametroDetalle}">
                    <legend class="float-none w-auto px-3 bg-secondary border rounded-3 text-white fs-6"
                        *ngIf="(solicitud.tipoTransporteId == $parametricList.typeTransportList[0]?.idParametroDetalle || solicitud.tipoTransporteId == $parametricList.typeTransportList[1]?.idParametroDetalle) && solicitud.tipoServicioId == $parametricList.typeServicesList[0]?.idParametroDetalle">
                        RECORRIDO {{ i > 0 ? i : '' }}
                    </legend>

                    <div class="row py-1 g-3">
                        <div class="col-md-4">
                            <label for="vcLugarSalida" class="form-label">Lugar de salida<strong
                                    class="text-danger">*</strong></label>
                            <input type="text" class="form-control" id="vcLugarSalida"
                                [(ngModel)]="recorrido.vcLugarSalida" name="vcLugarSalida" #vcLugarSalida="ngModel"
                                required [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">

                            <strong class="invalid-feedback d-block"
                                *ngIf="vcLugarSalida.invalid && (vcLugarSalida.dirty || vcLugarSalida.touched || submitted)">
                                <span *ngIf="vcLugarSalida.errors?.['required']">
                                    Campo obligatorio
                                </span>
                            </strong>
                        </div>

                        <div class="col-md-4">
                            <label for="vcLugarDestino" class="form-label">Lugar de destino<strong
                                    class="text-danger">*</strong></label>
                            <input type="text" class="form-control" id="vcLugarDestino"
                                [(ngModel)]="recorrido.vcLugarDestino" name="vcLugarDestino" #vcLugarDestino="ngModel"
                                required [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">

                            <strong class="invalid-feedback d-block"
                                *ngIf="vcLugarDestino.invalid && (vcLugarDestino.dirty || vcLugarDestino.touched || submitted)">
                                <span *ngIf="vcLugarDestino.errors?.['required']">
                                    Campo obligatorio
                                </span>
                            </strong>
                        </div>

                        <div class="col-md-4">
                            <label for="dtHoraSalidaString" class="form-label">Hora de salida<strong
                                    class="text-danger">*</strong></label>
                            <input type="time" class="form-control" id="dtHoraSalidaString"
                                [(ngModel)]="recorrido.dtHoraSalidaString" name="dtHoraSalidaString"
                                #dtHoraSalidaString="ngModel" required
                                [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">

                            <strong class="invalid-feedback d-block"
                                *ngIf="dtHoraSalidaString.invalid && (dtHoraSalidaString.dirty || dtHoraSalidaString.touched || submitted)">
                                <span *ngIf="dtHoraSalidaString.errors?.['required']">
                                    Campo obligatorio
                                </span>
                            </strong>
                        </div>

                        <div class="col-md-4"
                            *ngIf="solicitud.tipoServicioId != $parametricList.typeServicesList[1]?.idParametroDetalle">
                            <label for="dtHoraRecogidaString" class="form-label">Hora de recogida<strong
                                    class="text-danger">*</strong></label>
                            <input type="time" class="form-control" id="dtHoraRecogidaString"
                                [(ngModel)]="recorrido.dtHoraRecogidaString" name="dtHoraRecogidaString"
                                #dtHoraRecogidaString="ngModel" required
                                [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">

                            <strong class="invalid-feedback d-block"
                                *ngIf="dtHoraRecogidaString.invalid && (dtHoraRecogidaString.dirty || dtHoraRecogidaString.touched || submitted)">
                                <span *ngIf="dtHoraRecogidaString.errors?.['required']">
                                    Campo obligatorio
                                </span>
                            </strong>
                        </div>

                        <div class="col-md-4"
                            *ngIf="solicitud.tipoServicioId != $parametricList.typeServicesList[1]?.idParametroDetalle">
                            <label for="dtHoraRegresoString" class="form-label">Hora de regreso<strong
                                    class="text-danger">*</strong></label>
                            <input type="time" class="form-control" id="dtHoraRegresoString"
                                [(ngModel)]="recorrido.dtHoraRegresoString" name="dtHoraRegresoString"
                                #dtHoraRegresoString="ngModel" required
                                [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">

                            <strong class="invalid-feedback d-block"
                                *ngIf="dtHoraRegresoString.invalid && (dtHoraRegresoString.dirty || dtHoraRegresoString.touched || submitted)">
                                <span *ngIf="dtHoraRegresoString.errors?.['required']">
                                    Campo obligatorio
                                </span>
                            </strong>
                        </div>

                        <div class="col-md-4"
                            *ngIf="(solicitud.tipoTransporteId == $parametricList.typeTransportList[0]?.idParametroDetalle || solicitud.tipoTransporteId == $parametricList.typeTransportList[1]?.idParametroDetalle) && solicitud.tipoServicioId == $parametricList.typeServicesList[0]?.idParametroDetalle">
                            <label for="id" class="form-label">Incluir recorridos adicionales</label>

                            <div class="row g-2">
                                <div class="col-md-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="{{i}}" id="si" [value]="true"
                                            [(ngModel)]="recorrido.btTieneRecorridoAdicional"
                                            (change)="enableRoutePlus()"
                                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                                        <label class="form-check-label" for="si">
                                            SI
                                        </label>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="{{i}}" id="no"
                                            [value]="false" [(ngModel)]="recorrido.btTieneRecorridoAdicional"
                                            (change)="disabledRoutePlus(i)"
                                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                                        <label class="form-check-label" for="no">
                                            NO
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</ng-template>

<!-- SECCION 3 Datos de la dependencia vinculada al servicio -->
<ng-template #seccion_3>
    <div>
        <h6 class="text-secondary fw-bold">Datos de la dependencia vinculada al servicio</h6>

        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <div class="p-4">
                <div class="row py-2">
                    <div class="col-md-4">
                        <label for="dependenciaId" class="form-label">Dependencias</label>
                        <select id="dependenciaId" class="form-select" aria-label="Default select example"
                            [(ngModel)]="solicitud.dependenciaId" name="dependenciaId" #dependenciaId="ngModel" required
                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                            <option selected disabled>Seleccionar</option>
                            <option *ngFor="let typeDependenciesList of $parametricList.typeDependenciesList"
                                [value]="typeDependenciesList.idParametroDetalle">
                                {{ typeDependenciesList.vcNombre }}
                            </option>
                        </select>

                        <strong class="invalid-feedback d-block"
                            *ngIf="dependenciaId.invalid && (dependenciaId.dirty || dependenciaId.touched || submitted)">
                            <span *ngIf="dependenciaId.errors?.['required']">
                                Campo obligatorio
                            </span>
                        </strong>
                    </div>

                    <div class="col-md-4">
                        <label for="directorJefeDependenciaId" class="form-label">Nombre del director o jefe de
                            dependencia</label>
                        <select id="directorJefeDependenciaId" class="form-select" aria-label="Default select example"
                            [(ngModel)]="solicitud.directorJefeDependenciaId" name="directorJefeDependenciaId"
                            #directorJefeDependenciaId="ngModel" required
                            [disabled]="$views !== 1 && $views !== 6  && $views !== 8 && $views !== 9">
                            <option selected disabled>Seleccionar</option>
                            <option *ngFor="let typeManagersList of $parametricList.typeManagersList"
                                [value]="typeManagersList.idParametroDetalle">
                                {{ typeManagersList.vcNombre }}
                            </option>
                        </select>

                        <strong class="invalid-feedback d-block"
                            *ngIf="directorJefeDependenciaId.invalid && (directorJefeDependenciaId.dirty || directorJefeDependenciaId.touched || submitted)">
                            <span *ngIf="directorJefeDependenciaId.errors?.['required']">
                                Campo obligatorio
                            </span>
                        </strong>
                    </div>

                    <div class="col-md-4">
                        <label for="ids" class="form-label">ID Asociado</label>
                        <input id="ids" type="text" class="form-control" [(ngModel)]="solicitud.id" name="id" disabled>
                    </div>
                </div>

                <br>
                <br>

                <div *ngIf="$views !== 5 && $views !== 9 && $views !== 10">
                    <div class="py-3">
                        <app-table-officials
                            [$viewButton]="($views === 1 || $views === 6 || $views === 8) ? true : false"
                            [($pasajeros)]="solicitud.pasajeros"></app-table-officials>
                    </div>

                    <div class="row py-1">
                        <div class="col-md-4">
                            <label for="bEsResponsableServicio" class="form-label">Responsable del servicio*</label>
                            <select class="form-select" aria-label="Default select example" id="bEsResponsableServicio"
                                name="btTieneRecorridoAdicional" (change)="responsableSeleccionado($event)" required
                                [disabled]="$views !== 1 && $views !== 6  && $views !== 8">
                                <option>Seleccionar</option>
                                <option *ngFor="let pasajero of solicitud.pasajeros; let i = index"
                                    [value]="pasajero.id || i" [selected]="pasajero.bEsResponsableServicio">
                                    {{ pasajero.vcPrimerNombre + ' ' + pasajero.vcPrimerApellido }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row py-1">
                        <div class="col-12">
                            <label for="id" class="form-label">Justificación*</label>
                            <textarea class="form-control" rows="5" max="800" [(ngModel)]="solicitud.txJustificacion"
                                name="txJustificacion" #txJustificacion="ngModel" maxlength="800" required
                                [disabled]="$views !== 1 && $views !== 6  && $views !== 8">
                            </textarea>

                            <strong class="invalid-feedback d-block"
                                *ngIf="txJustificacion.invalid && (txJustificacion.dirty || txJustificacion.touched || submitted)">
                                <span *ngIf="txJustificacion.errors?.['required']">
                                    Campo obligatorio
                                </span>
                                <span *ngIf="txJustificacion.errors?.['maxlength']">
                                    Máximo 800 caracteres
                                </span>
                            </strong>
                        </div>
                    </div>

                    
                    <!-- SECCION SOLICITUD DE SERVICIO EXTEMPORANEA -->
                    <div class="row py-1" *ngIf="$views === 8">
                        <br>
                        <br>
                        <h6 class="text-secondary fw-bold">Soporte de la radicación de la solicitud extemporánea</h6>
                        <br>
                        <span>Por favor adjuntar el correo y/o comunicación que autoriza la radicación de la solicitud
                            extemporánea del servicio en formato PDF</span>
                        <br>
                        <br>
                        <div class="container d-flex flex-row gap-3">
                            <div class="col-md-4">
                                <input id="file" type="text" class="form-control" [value]="fileTmp.fileName || ''"
                                    name="file" required disabled>
                            </div>

                            <div class="col-md-2">
                                <button class="btn btn-outline-secondary btn-sm mt-1" (click)="importSupport.click()">
                                    <i class="fa-solid fa-paperclip"></i>
                                </button>

                                <input type="file" (change)="getFile($event)" accept="application/pdf" class="d-none"
                                    #importSupport />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>
</ng-template>

<!-- SECCION 4 Validación Datos -->
<ng-template #seccion_4>
    <div>
        <h6 class="text-secondary fw-bold">Validación Datos</h6>
        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <div class="row container">
                <div class="col-12">
                    <label for="" class="form-label">Observaciones*</label>
                    <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                        disabled>{{solicitud.txtObservacionDatosValidacion}}</textarea>
                </div>
            </div>
        </div>
    </div>
    <br>
</ng-template>

<!-- SECCION 5 Rechazo directivo -->
<ng-template #seccion_5>
    <div>
        <h6 class="text-secondary fw-bold">Rechazo directivo</h6>
        <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <div class="row container">
                <div class="col-12">
                    <label for="" class="form-label">Observaciones*</label>
                    <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                        disabled>{{solicitud.txtObservacionRechazo}}</textarea>
                </div>
            </div>
        </div>
    </div>
    <br>
</ng-template>


<!-- SECCION NOVEDADES EN LA SOLICITUD DEL SERVICIO -->
<ng-template #seccion_novedades>
    <app-table-news-request [dataTable]="solicitud.novedades">
    </app-table-news-request>

    <br>
    <br>
</ng-template>

<!-- SECCION CANCELACION DE LA SOLICITUD DE SERVICIO -->
<ng-template #seccion_cancelacion>
    <h6 class="text-secondary fw-bold">Cancelación de la solicitud de servicio</h6>

    <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
        <br>
        <div class="row container">
            <div class="col-md-4">
                <label for="motivoId" class="form-label">Motivo de la cancelación*</label>
                <select id="motivoId" class="form-select" aria-label="Default select example" name="motivoId"
                    [(ngModel)]="solicitud.motivoCancelacionId" disabled>
                    <option selected disabled>Seleccionar</option>
                    <option *ngFor="let option of $parametricList.typeCancellationsList"
                        [value]="option.idParametroDetalle">
                        {{option.vcNombre}}
                    </option>
                </select>
            </div>

            <div class="col-md-4">
                <label for="ids" class="form-label">ID Asociado</label>
                <input id="ids" type="text" class="form-control" [value]="solicitud.id" name="id" disabled>
            </div>
        </div>

        <br>

        <div class="row container">
            <div class="col-12">
                <label for="" class="form-label">Justificación*</label>
                <textarea class="form-control" rows="2" maxlength="800" name="justificacion"
                    disabled>{{solicitud.txtObservacion}}</textarea>
            </div>
        </div>
    </div>

</ng-template>

<!-- SECCION VALIDACION DE DATOS DE LA SOLICITUD DE SERVICIO -->
<ng-template #seccion_validacion_datos>
    <h6 class="text-secondary fw-bold">Validación de datos de la solicitud de servicio</h6>

    <div class="p-4 card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
        <div class="col-12">
            <label for="id" class="form-label">Validación de datos</label>
            <textarea class="form-control" rows="4" name="txtObservacionDatosValidacion" disabled>{{solicitud.txtObservacionDatosValidacion}}</textarea>
        </div>
    </div>
</ng-template>

<!-- SECCION MOTIVO DE RECHAZO DE LA SOLICITUD DE SERVICIO -->
<ng-template #seccion_solicitudes_vinculadas>
    <h6 class="text-secondary fw-bold">Solicitudes vinculadas</h6>

    <div class="card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
        <br>
        <div class="container overflow-auto">
            <table class="table table-bordered text-center">
                <thead>
                    <tr>
                        <th scope="col">Solicitud Principal Id</th>
                        <th scope="col">Solicitud Secundaria Id</th>
                        <th scope="col">Solicitud Vinculada Id</th>
                        <th scope="col">Fecha de registro</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of solicitud.relacionadas">
                        <td>{{data.solicitudPrincipalId}}</td>
                        <td>{{data.solicitudSecundariaId}}</td>
                        <td>{{data.solicitudClonadaId}}</td>
                        <td>{{data.dtFechaRegistro | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>

<!-- SECCION BOTONES PANTALLA 2.6 AJUSTES -->
<ng-template #seccion_botones_pantalla_6>
    <div class="d-flex flex-row justify-content-end">
        <button class="btn btn-secondary col-2 m-1" (click)="updateSolicitudDisponible()">ACTUALIZAR SOLICITUD</button>
        <button class="btn btn-secondary col-2 m-1" (click)="addNovedad(novedad)">AGREGAR NOVEDAD</button>
        <button class="btn btn-secondary col-2 m-1" [routerLink]="['/seguimiento-solicitudes-referente']">CANCELAR
            SOLICITUD</button>
    </div>
</ng-template>


<!-- MODAL AGREGAR NOVEDAD EN LA SOLICITUD DEL SERVICIO -->
<ng-template #novedad let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Agregar novedad en la solicitud de servicio</strong>
        </h4>
    </div>

    <div class="modal-body py-3">
        <app-agregar-novedad [codeSolicitud]="solicitud.id" [solicitud]="solicitud" (cancel)="addNovedad($event)"
            (reloadTable)="getSolicitudById($event)">

        </app-agregar-novedad>
    </div>
</ng-template>